import React from "react";
import Event from "../../components/Event";

const events = [
        {
                id: 1,
                title: "Student Registration",
                dateString: "14 OCT 2026 - 9 DEC 2026",
                startDate: new Date("2026-10-13T07:00:00"),
                endDate: new Date("2026-12-09T18:00:00"),
                description: "Register your students to compete in the 2026 BAO.",
        },
        {
                id: 2,
                title: "Round One Window",
                dateString: "11 NOV 2026 - 9 DEC 2026",
                startDate: new Date("2026-11-11T07:00:00"),
                endDate: new Date("2026-12-09T18:00:00"),
                description: "Your students can sit the first-round paper at any point in this period.",
        },
        {
                id: 3,
                title: "Marks Submission",
                dateString: "11 NOV 2026 - 16 DEC 2026",
                startDate: new Date("2026-11-11T07:00:00"),
                endDate: new Date("2026-12-16T18:00:00"),
                description: "Add and update your students’ marks until the deadline.",
        },
        {
                id: 4,
                title: "Round One Results",
                dateString: "6 JAN 2027",
                startDate: new Date("2027-01-06T07:00:00"),
                endDate: new Date("2027-01-06T07:00:00"),
                description: "View your students’ results and certificates, including any final round invitations.",
        },
        {
                id: 5,
                title: "Final Round",
                dateString: "FEB/MAR 2027 (TBC)",
                startDate: new Date("2027-03-28T07:00:00"),
                endDate: new Date("2027-03-28T18:00:00"),
                description: "The final round of the 2026/27 BAO for those invited following round one.",
        },
        {
                id: 6,
                title: "Final Results",
                dateString: "MAR/APR 2027 (TBC)",
                startDate: new Date("2027-04-08T07:00:00"),
                endDate: new Date("2027-04-08T07:00:00"),
                description: "The results for the final round of the competition.",
        }
];

const Timeline = () => {
        const currentDate = new Date();

        return (
                <div className="timeline">
                        <div className="timeline-line"></div>
                        {events.map((event) => (
                                <Event event={event} currentDate={currentDate} key={event.id} />
                        ))}
                </div>
        );
};

export default Timeline;